<template>
	<div class="data-center">
		<kid-tabs type="card" tab-position="left" v-model="food" @tab-click="handleTab">
			<kid-tab-pane label="数据中心" :is-title="true"></kid-tab-pane>
			<kid-tab-pane label="基础数据" :is-group="true"></kid-tab-pane>
			<kid-tab-pane label="食材" name="food">
				<router-view name="ingredient"></router-view>
			</kid-tab-pane>
			<kid-tab-pane label="菜品" name="dishes">
				<router-view name="dishes"></router-view>
			</kid-tab-pane>
			<kid-tab-pane label="食谱库">角色管理</kid-tab-pane>
			<kid-tab-pane label="计算标准" :is-group="true"></kid-tab-pane>
			<kid-tab-pane label="营养标准" name="basis">
				<router-view name="basis"></router-view>
			</kid-tab-pane>
			<kid-tab-pane label="健康评估"></kid-tab-pane>
			<kid-tab-pane label="运营设置" :is-group="true"></kid-tab-pane>
			<kid-tab-pane label="区域设置" name="area">
				<router-view name="area"></router-view>
			</kid-tab-pane>
			<kid-tab-pane label="系统设置" name="sysset">
				<router-view name="sysset"></router-view>
			</kid-tab-pane>
		</kid-tabs>
	</div>
</template>
<script>
import {KidTabs,KidTabPane} from '@/components/KidGroupTab/index'
export default {
	components: {
		KidTabs,
		KidTabPane
	},
	created() {
		this.showTab();
	},
	data(){
		return {
			food: 'food'
		}
	},
	methods:{
		handleTab(tab) {
			if(tab.name == 'food') {
				this.$router.push({'path':'/datacenter/dclist/datalist'})
			}
			if(tab.name == 'area') {
				this.$router.push({'path':'/datacenter/areaset/arealist'})
			}
			if(tab.name == 'sysset') {
				this.$router.push({'path':'/datacenter/sysset/sysm'})
			}
			if(tab.name == 'dishes') {
				this.$router.push({'path':'/datacenter/dishes/dishesList'})
			}
			if(tab.name == 'basis') {
				this.$router.push({'path':'/datacenter/basis/dirsyearlist'})
			}
		},
		showTab() {
			const name = this.$route.meta.tab;
			this.food = name;
		}
	}
}
</script>
<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/datacenter/index.vue